import React from 'react';

const ExperiencesSection = () => {
    return (
        <h3>Experiences section</h3>
    );
};

export default ExperiencesSection;